import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { axiosErrorHandler } from 'common/helpers/axios.helper';
import { AppDispatch, RootState } from 'app/store';
import { IBuyer } from 'entities/Buyer/Buyer.models';
import { buyersTransport } from 'entities/Buyer/Buyer.transport';

interface IState {
  buyerList: IBuyer[];
  buyerCount: number;
  isBuyerLoading: boolean;
}

const initialState: IState = {
  buyerList: [],
  buyerCount: 0,
  isBuyerLoading: false,
};

export const buyerSlice = createSlice({
  name: 'buyer',
  initialState,
  reducers: {
    setBuyerList(state, action: PayloadAction<IBuyer[]>) {
      state.buyerList = action.payload;
    },
    setBuyerCount(state, action: PayloadAction<number>) {
      state.buyerCount = action.payload;
    },
    setIsBuyerLoading(state, action: PayloadAction<boolean>) {
      state.isBuyerLoading = action.payload;
    },
  },
});

export const { setBuyerList, setBuyerCount, setIsBuyerLoading } = buyerSlice.actions;

export const selectBuyerList = (state: RootState) => state.buyer.buyerList;
export const selectBuyerCount = (state: RootState) => state.buyer.buyerCount;
export const selectIsBuyerLoading = (state: RootState) => state.buyer.isBuyerLoading;

export const buyerReducer = buyerSlice.reducer;

export const getBuyerList = () => async (dispatch: AppDispatch) => {
  dispatch(setIsBuyerLoading(true));

  try {
    const response = await buyersTransport.get();
    dispatch(setBuyerList(response.data));
    dispatch(setBuyerCount(response.count));
  } catch (error) {
    axiosErrorHandler(error);
  } finally {
    dispatch(setIsBuyerLoading(false));
  }
};
